/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateGroupDto,
  CreateGroupResultDto,
  DissolveGroupResultDto,
  GroupDetailDto,
  InviteGroupMemberDto,
  InviteGroupMemberResultDto,
  LeaveGroupResultDto,
  RemoveGroupMemberResultDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * The caller must be an independent farmer (principal_type=individual, no cooperative). disclosureAccepted must be literally true — it records that the lead has seen the POPIA disclosure that they vouch for members but are NOT each member's Information Officer. 404 if the caller has no farm profile; 409 if already in a cooperative or group. NOTE: the caller's existing JWT still carries role='farmer'; the client must call POST /auth/refresh to obtain a token with role='group_lead' (refresh re-reads role from the DB).
 * @summary Create an informal farmer group (G2); the caller becomes its lead
 */
export const groupsControllerCreateGroup = (
    createGroupDto: CreateGroupDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<CreateGroupResultDto>(
      {url: `/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupDto, signal
    },
      );
    }
  


export const getGroupsControllerCreateGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerCreateGroup>>, TError,{data: CreateGroupDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof groupsControllerCreateGroup>>, TError,{data: CreateGroupDto}, TContext> => {

const mutationKey = ['groupsControllerCreateGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof groupsControllerCreateGroup>>, {data: CreateGroupDto}> = (props) => {
          const {data} = props ?? {};

          return  groupsControllerCreateGroup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GroupsControllerCreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof groupsControllerCreateGroup>>>
    export type GroupsControllerCreateGroupMutationBody = CreateGroupDto
    export type GroupsControllerCreateGroupMutationError = unknown

    /**
 * @summary Create an informal farmer group (G2); the caller becomes its lead
 */
export const useGroupsControllerCreateGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerCreateGroup>>, TError,{data: CreateGroupDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof groupsControllerCreateGroup>>,
        TError,
        {data: CreateGroupDto},
        TContext
      > => {

      const mutationOptions = getGroupsControllerCreateGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resolves the is_formal=false cooperative where the caller is the lead (admin_user_id) OR a member (farmer_profiles.cooperative_id). The roster includes the lead, lead-first then oldest-first. 404 if the caller is not in a group.
 * @summary The caller's informal group + roster
 */
export const groupsControllerGetMine = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<GroupDetailDto>(
      {url: `/groups/mine`, method: 'GET', signal
    },
      );
    }
  



export const getGroupsControllerGetMineQueryKey = () => {
    return [
    `/groups/mine`
    ] as const;
    }

    
export const getGroupsControllerGetMineQueryOptions = <TData = Awaited<ReturnType<typeof groupsControllerGetMine>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetMine>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupsControllerGetMineQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupsControllerGetMine>>> = ({ signal }) => groupsControllerGetMine(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetMine>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GroupsControllerGetMineQueryResult = NonNullable<Awaited<ReturnType<typeof groupsControllerGetMine>>>
export type GroupsControllerGetMineQueryError = unknown


export function useGroupsControllerGetMine<TData = Awaited<ReturnType<typeof groupsControllerGetMine>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetMine>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsControllerGetMine>>,
          TError,
          Awaited<ReturnType<typeof groupsControllerGetMine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGroupsControllerGetMine<TData = Awaited<ReturnType<typeof groupsControllerGetMine>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetMine>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupsControllerGetMine>>,
          TError,
          Awaited<ReturnType<typeof groupsControllerGetMine>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGroupsControllerGetMine<TData = Awaited<ReturnType<typeof groupsControllerGetMine>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetMine>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary The caller's informal group + roster
 */

export function useGroupsControllerGetMine<TData = Awaited<ReturnType<typeof groupsControllerGetMine>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupsControllerGetMine>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGroupsControllerGetMineQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * If a user with this phone already exists and is an independent farmer they are ATTACHED (outcome='attached'); otherwise a claimable account is created (outcome='invited', pin_hash NULL → /auth/claim). 400 if the caller does not lead a group; 409 if the phone already belongs to a cooperative or group member.
 * @summary Invite a member by phone into the caller's group
 */
export const groupsControllerInviteMember = (
    inviteGroupMemberDto: InviteGroupMemberDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<InviteGroupMemberResultDto>(
      {url: `/groups/members/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteGroupMemberDto, signal
    },
      );
    }
  


export const getGroupsControllerInviteMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerInviteMember>>, TError,{data: InviteGroupMemberDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof groupsControllerInviteMember>>, TError,{data: InviteGroupMemberDto}, TContext> => {

const mutationKey = ['groupsControllerInviteMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof groupsControllerInviteMember>>, {data: InviteGroupMemberDto}> = (props) => {
          const {data} = props ?? {};

          return  groupsControllerInviteMember(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GroupsControllerInviteMemberMutationResult = NonNullable<Awaited<ReturnType<typeof groupsControllerInviteMember>>>
    export type GroupsControllerInviteMemberMutationBody = InviteGroupMemberDto
    export type GroupsControllerInviteMemberMutationError = unknown

    /**
 * @summary Invite a member by phone into the caller's group
 */
export const useGroupsControllerInviteMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerInviteMember>>, TError,{data: InviteGroupMemberDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof groupsControllerInviteMember>>,
        TError,
        {data: InviteGroupMemberDto},
        TContext
      > => {

      const mutationOptions = getGroupsControllerInviteMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Un-links the member back to independent (G1): cooperative_id NULL, principal_type='individual'. 400 if the caller does not lead a group or tries to remove themselves (dissolve instead); 404 if the target isn't a member of the caller's group.
 * @summary Remove a member from the caller's group
 */
export const groupsControllerRemoveMember = (
    userId: string,
 ) => {
      
      
      return fseAxios<RemoveGroupMemberResultDto>(
      {url: `/groups/members/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getGroupsControllerRemoveMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerRemoveMember>>, TError,{userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof groupsControllerRemoveMember>>, TError,{userId: string}, TContext> => {

const mutationKey = ['groupsControllerRemoveMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof groupsControllerRemoveMember>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  groupsControllerRemoveMember(userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GroupsControllerRemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof groupsControllerRemoveMember>>>
    
    export type GroupsControllerRemoveMemberMutationError = unknown

    /**
 * @summary Remove a member from the caller's group
 */
export const useGroupsControllerRemoveMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerRemoveMember>>, TError,{userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof groupsControllerRemoveMember>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getGroupsControllerRemoveMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Un-links the caller back to independent (G1). 400 if the caller is not an informal_group member, or is the lead of the group (the lead must dissolve, not leave).
 * @summary Leave the caller's informal group (members only, not the lead)
 */
export const groupsControllerLeaveGroup = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<LeaveGroupResultDto>(
      {url: `/groups/leave`, method: 'POST', signal
    },
      );
    }
  


export const getGroupsControllerLeaveGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerLeaveGroup>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof groupsControllerLeaveGroup>>, TError,void, TContext> => {

const mutationKey = ['groupsControllerLeaveGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof groupsControllerLeaveGroup>>, void> = () => {
          

          return  groupsControllerLeaveGroup()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GroupsControllerLeaveGroupMutationResult = NonNullable<Awaited<ReturnType<typeof groupsControllerLeaveGroup>>>
    
    export type GroupsControllerLeaveGroupMutationError = unknown

    /**
 * @summary Leave the caller's informal group (members only, not the lead)
 */
export const useGroupsControllerLeaveGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerLeaveGroup>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof groupsControllerLeaveGroup>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getGroupsControllerLeaveGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Deletes the group and returns the lead to independent (G1). 400 if the caller does not lead a group, if members remain (remove them first), or if group harvests (batches) remain (settle/cancel first). NOTE: the client must call POST /auth/refresh to drop the role='group_lead' from its token.
 * @summary Dissolve the caller's group (lead only, when sole member)
 */
export const groupsControllerDissolveGroup = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<DissolveGroupResultDto>(
      {url: `/groups/dissolve`, method: 'POST', signal
    },
      );
    }
  


export const getGroupsControllerDissolveGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerDissolveGroup>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof groupsControllerDissolveGroup>>, TError,void, TContext> => {

const mutationKey = ['groupsControllerDissolveGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof groupsControllerDissolveGroup>>, void> = () => {
          

          return  groupsControllerDissolveGroup()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GroupsControllerDissolveGroupMutationResult = NonNullable<Awaited<ReturnType<typeof groupsControllerDissolveGroup>>>
    
    export type GroupsControllerDissolveGroupMutationError = unknown

    /**
 * @summary Dissolve the caller's group (lead only, when sole member)
 */
export const useGroupsControllerDissolveGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof groupsControllerDissolveGroup>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof groupsControllerDissolveGroup>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getGroupsControllerDissolveGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    